<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.carriers.carriersCode')" prop="supplierCode">
                <el-input class="handle-input" v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                <el-input v-model="queryCondition.type" v-show="false" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.carriers.carriersName')" prop="supplierName">
                <el-input class="handle-input" v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.common.status')" prop="status">
                <el-select v-model="queryCondition.status" class="handle-input" style="width:100%">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in supplierStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="addCarrier" v-acl="SupplierAdd">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="primary" @click="disableCarrier" v-acl="SupplierDisable">{{$t('base.common.statusDisable')}}</el-button>
      </el-row>
      <el-table :data="tableData" @selection-change="findCarrierCode" border max-height='1610' highlight-current-row>
        <el-table-column sortable prop="supplierCode" type="selection" width="55" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierCode" align="center" :label="$t('base.carriers.carriersCode')">
          <template slot-scope="scope">
            <div class="a-link" @click="toDetail(scope.row.tmSupplierId)">{{scope.row.supplierCode}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" :label="$t('base.carriers.carriersName')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="city" align="center" :label="$t('base.carriers.carriersCity')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="emailAddress" align="center" :label="$t('base.common.emailAddress')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="updateUserName" align="center" :label="$t('base.common.updateBy')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="updateDate" align="center" :label="$t('base.common.updateDate')">
          <template slot-scope="scope">
            {{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" align="center" :label="$t('base.common.status')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { search, disable } from "../../../api/base-data/supplier";
import { Message } from "element-ui";
import { inputChoiceService } from "../../../api/common/input-choice";
export default {
  name: 'carriers',
  data() {
    return {
      isProhibit: true,
      carriers: [],
      carriersList: [],
      tableData: [],
      totalCount: 0,
      labelPosition: 'right',
      supplierStatusList: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        status: '',
        supplierCode: '',
        supplierName: '',
        type: 'CARRIER',
      },
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      search(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    //禁用承运商
    disableCarrier() {
      if (this.carriers.length == 0) {
        Message({ message: this.$t('base.carriers.carriersSelect'), type: "warning" });
      } else {
        let carriersList = this.carriersList
        for (let i = 0, len = carriersList.length; i < len; i++) {
          if (carriersList[i].status == 0) {
            Message({ message: '所选数据已有禁用状态，重新选择', type: "success" });
            return false;
          }
        }
        this.$confirm(this.$t('common.disableWarning'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          disable(this.carriers).then((res) => {
            if (res.resultData > 0) {
              Message({ message: this.$t('common.disableSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.disableError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },

    //获取下拉列表数据
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.supplierStatusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },

    //获取选中承运商编号
    findCarrierCode(val) {
      let that = this
      this.carriers = [];
      this.carriersList = [];
      val.forEach((item) => {
        that.carriers.push(item.tmSupplierId);
        that.carriersList.push(item)
      });
    },
    //新增承运商
    addCarrier() {
      this.$router.replace({
        name: 'carrier-add'
      });
    },
    //分页查询页数变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //分页查询每页显示数量变化
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryData();
    },
    toDetail(id) {
      if (this.actionCheck.actionCheck('SupplierEdit') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.push({
        path: `/carrier-modify`,
        query: { tmSupplierId: id }
      });
    },
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.dialog-input {
  width: 40%;
}
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
</style>
